var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollctivThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 8.50001V20.5M19 8.50001H11.356L12.828 4.61101C13.205 3.61501 12.87 2.47601 12.026 1.88101C11.062 1.20201 9.762 1.45401 9.089 2.45001L5 8.50001V17.5C5 18.5609 5.42143 19.5783 6.17157 20.3284C6.92172 21.0786 7.93913 21.5 9 21.5H15.516C16.2571 21.5001 16.9837 21.2942 17.6146 20.9054C18.2455 20.5166 18.756 19.9601 19.089 19.298L21 15.5V10.5C21 9.96958 20.7893 9.46087 20.4142 9.0858C20.0391 8.71073 19.5304 8.50001 19 8.50001Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollctivThumb);
export default __webpack_public_path__ + "static/media/collctivThumb.8b2cbaf267bf91846c897f512528253f.svg";
export { ForwardRef as ReactComponent };